import React from 'react';
import {
    List, Datagrid, TextField, Edit, SimpleForm, FunctionField, DateField,
    TextInput, Toolbar, SaveButton, Create, Filter, NumberInput, downloadCSV
} from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import { useMediaQuery } from '@mui/material';

export const NomenclatoreList = props => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return (
        <List empty={false} filters={<NomenclatoreFilter />} exporter={exporter}   {...props}>
            {isSmall ? (
                <Datagrid rowClick="edit" bulkActionButtons={false}>
                    <TextField source="cod_nmu" label="Codigo Numerico" />
                    <TextField source="desc_nmu" label="Descrizione" />
                </Datagrid>
            ) : (
                <Datagrid rowClick="edit" bulkActionButtons={false}>
                    <TextField source="cod_nmu" />
                    <TextField source="desc_nmu" />
                    <TextField source="cod_gruppo_tec" />
                    <TextField source="tipo_propr_materiale" />
                    <TextField source="divresp" />
                    <FunctionField label="NMU Compatibile" render={
                        record => record.comp_nmu ? record.comp_nmu.map(x => {
                            return x + ' '
                        }
                        ) : undefined
                    } />
                    <TextField source="tipo_famiglia" />
                    <TextField source="flag_gest_centr" />
                    <DateField source="data_inizio_gest_centr" locales="it-IT" />
                    <DateField source="data_fine_gest_centr" locales="it-IT" />
                </Datagrid>
            )}
        </List>
    )
};

const exporter = nomenclatores => {
    const nomenclatoresForExport = nomenclatores.map(nomenclatore => {
        const { ...nomenclatoresForExport } = nomenclatore;
        nomenclatoresForExport['data_inizio_gest_centr'] = nomenclatore.data_inizio_gest_centr ? new Date(nomenclatore.data_inizio_gest_centr).toLocaleDateString() : "";
        nomenclatoresForExport['data_fine_gest_centr'] = nomenclatore.data_fine_gest_centr ? new Date(nomenclatore.data_fine_gest_centr).toLocaleDateString() : "";
        return nomenclatoresForExport;
    });
    const csv = convertToCSV({
        data: nomenclatoresForExport,
        fields: ['id', 'createdAt', 'updatedAt', 'cod_nmu', 'desc_nmu', 'cod_gruppo_tec', 'tipo_propr_materiale', 'gestito_con_sn', 'comp_nmu', 'flag_gest_centr',
             'data_inizio_gest_centr', 'data_fine_gest_centr', 'divresp', '__v']
    });
    downloadCSV(csv, 'nomenclatores');
}

const NomenclatoreTitle = ({ record }) => {
    return <span>Nomenclatore {record ? `${record.cod_nmu}` : ''}</span>;
};

export const NomenclatoreEdit = props => (
    <Edit title={<NomenclatoreTitle />} {...props}>
        <SimpleForm toolbar={<NomenclatoreEditToolbar />}>
            <TextInput source="cod_nmu" />
            <TextInput multiline source="desc_nmu" />
            <TextInput source="cod_gruppo_tec" />
            <TextInput source="tipo_propr_materiale" />
            <TextInput source="divresp" />
            <TextInput source="flag_gest_centr" />
            <TextInput source="data_inizio_gest_centr" />
            <TextInput source="data_fine_gest_centr" />
        </SimpleForm>
    </Edit>
);

const NomenclatoreEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

export const NomenclatoreCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="cod_nmu" />
            <TextInput multiline source="desc_nmu" />
            <TextInput source="cod_gruppo_tec" />
            <TextInput source="tipo_propr_materiale" />
            <TextInput source="divresp" />
            <TextInput source="flag_gest_centr" />
            <TextInput source="data_inizio_gest_centr" />
            <TextInput source="data_fine_gest_centr" />
        </SimpleForm>
    </Create>
);

const NomenclatoreFilter = (props) => (
    <Filter {...props}>
        <NumberInput source="cod_nmu" alwaysOn />
        <TextInput source="desc_nmu" alwaysOn />
    </Filter>
);